export default __webpack_public_path__ + "static/media/NotoSansSymbols2-Regular.9961a11e.ttf";